var debug_url = window.location.pathname;
var debug_urlsplit = location.href.split("narat=").slice(-1)[0];
var debug_urlsplit = debug_urlsplit.split("/").slice(-1)[0];
var receiveMessageCounter = 0;
var ServerResponseReceived = false;

// defines if get history must be called
var alreadyStarted = false;
if(debug_urlsplit == '?debug=1'){
  Raven.config('https://7e70cd867f3c41409cbd6bdb7cfa3e79@sentry.djebots.ch/7', {
    release: '2.0',
    environment: 'debug'
  }).install()

}else{
  Raven.config('https://7e70cd867f3c41409cbd6bdb7cfa3e79@sentry.djebots.ch/7', {
    release: '2.0',
    environment: 'production'
  }).install()
}
if(window.innerWidth < 640 ||window.innerHeight < 468){
    var full_screen = true;
    var bodyheight = window.innerHeight - 116;
}
else{
    var full_screen = false;
}

function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x1000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4();
};
var session = Cookies.get('guid');
    if(debug_urlsplit == '?debug=1'){console.log (session)}
    Cookies.set('guid', session);
var connected = false;

if (typeof djebots_webchat_widget_mode == 'undefined') {
    if(debug_urlsplit == '?debug=1'){console.log("djebots_webchat_widget_mode is undefined")}
    var path = window.location.pathname.split("/");
    if (path.length < 3) {
        if (!session || session.length == 0) {
            session = guid()
        }
        Cookies.set('guid', session);
        var newPath = "/" + path[1] + "/" + path[2] + "/" + session + "/" + path[3];
        if(debug_urlsplit == '?debug=1'){console.log(newPath);}
        window.location.href = newPath;
    };
} else {
    if(debug_urlsplit == '?debug=1'){console.log("djebots_webchat_widget_mode is defined")}
    if (!session || session.length == 0) {
        session = guid()
    }
    Cookies.set('guid', session);
}

var design_template='';
if(debug_urlsplit == '?debug=1'){console.log(window.view_as);}
var openChatBox = false;
if (!window.view_as) {
  if(debug_urlsplit == '?debug=1'){console.log("widget");}
    window.view_as = 'widget';
}
if (window.view_as == 'desktop'){
  if(debug_urlsplit == '?debug=1'){console.log("desktop");}
    openChatBox = true;
    var header ="<div class='cards'style='width:100%;height:100%;position: absolute;margin-bottom:0px;border-radius:0px;'><div class='card-widget-header' style='border-radius:0px;'v-bind:style='[cwidget_header]'><img :src='bot' class='card-widget-header-image' alt='' style='height: 40px;width: 40px;float: left;'><b class='card-widget-text'>{{apiData.bot_name}}</b></div><div class='card-body card-widget-body' id='chatBox' ref='scrollList'v-bind:style='[cwidget_body ]'>";
    var footer = "<div v-if='apiData.display_input_bar==true' v-show='input_bar' class='card-widget-footer'style='border-radius:0px;' v-bind:style='[cwidget_footer ]'>";
    var chatButton = '';
    var webviewTemplate = "<transition name='fade'><div v-if='ShowWebview'  id='bubble-webview-webchat' class='cards bubble-webview-webchat' v-bind:style='[bubble_card ]'><div class='cards-header' style='border-top-left-radius: 10px;border-top-right-radius: 10px;background-color: transparent;height: 50px;'><b>{{webViewTitle}}</b><button type='button' @click='closeWebView' class='close badge' data-dismiss='alert' aria-label='Close' style='font-size: xx-large;'><span class='customSpan-close' aria-hidden='true'>&times;</span></button></div><div class='cards-body bubble-body' style='padding:5px 0 0 0 ;'><iframe style='width:100%;height:100%;border:none;' :src='webViewUrl' ></iframe></div></div></transition> ";
}
else{
    openChatBox = false;
    if(!full_screen){
        var header = "<div v-if='show' class='cards card-widget' v-bind:style='[cwidget]' ><div class='card-widget-header' v-bind:style='[cwidget_header]'><img :src='bot' class='card-widget-header-image' alt='' style='height: 40px;width: 40px;float: left;'>  <b class='card-widget-text'>{{apiData.bot_name}}</b><button type='button' class='close card-widget-header-close' data-dismiss='alert' aria-label='Close' v-if='show' v-on:click='show = false,file_menu = false, bubble = false' style='height:auto' ><span aria-hidden='true' class='customSpan-close' style='vertical-align: -moz-middle-with-baseline;'>&times;</span></button></div><div class='card-body card-widget-body' id='chatBox' ref='scrollList'v-bind:style='[cwidget_body ]' @scroll='handleScroll'>";
        var webviewTemplate = "<transition name='fade'><div v-if='ShowWebview'  id='bubble-webview-webchat' class='cards bubble-webview-widget' v-bind:style='[bubble_card ]'><div class='cards-header' style='border-top-left-radius: 10px;border-top-right-radius: 10px;background-color: transparent;height: 50px;'><b>{{webViewTitle}}</b><button type='button' @click='closeWebView' class='close badge' data-dismiss='alert' aria-label='Close' style='font-size: xx-large;'><span class='customSpan-close' aria-hidden='true'>&times;</span></button></div><div class='cards-body bubble-body' style='padding:5px 0 0 0 ;'><iframe style='width:100%;height:100%;border:none;' :src='webViewUrl' ></iframe></div></div></transition> ";

    }
    else{
        var header = "<div v-if='show' class='cards card-widget'  v-bind:style='[cwidget]' style='width:100%;height:100%;margin-bottom:0px;border-radius:0px;top:0;right:0;'><div class='card-widget-header' v-bind:style='[cwidget_header]'><img :src='bot' class='card-widget-header-image' alt='' style='height: 40px;width: 40px;float: left;'>  <b class='card-widget-text'>{{apiData.bot_name}}</b><button type='button' class='close card-widget-header-close' data-dismiss='alert' aria-label='Close' v-if='show' v-on:click='show = false,file_menu = false, bubble = false' style='height:auto' ><span aria-hidden='true' class='customSpan-close' style='vertical-align: -moz-middle-with-baseline;'>&times;</span></button></div><div class='card-body card-widget-body' id='chatBox' ref='scrollList'v-bind:style='[cwidget_body ]' @scroll='handleScroll'>";
        var webviewTemplate = "<transition name='fade'><div v-if='ShowWebview'  id='bubble-webview-webchat' class='cards bubble-webview-webchat' v-bind:style='[bubble_card ]'><div class='cards-header' style='border-top-left-radius: 10px;border-top-right-radius: 10px;background-color: transparent;height: 50px;'><b>{{webViewTitle}}</b><button type='button' @click='closeWebView' class='close badge' data-dismiss='alert' aria-label='Close' style='font-size: xx-large;'><span class='customSpan-close' aria-hidden='true'>&times;</span></button></div><div class='cards-body bubble-body' style='padding:5px 0 0 0 ;'><iframe style='width:100%;height:100%;border:none;' :src='webViewUrl' ></iframe></div></div></transition> ";

    }
    var footer = "<div v-if='apiData.display_input_bar==true' v-show='input_bar' class='card-widget-footer'v-bind:style='[cwidget_footer ]'>";
    var chatButton = "<transition name='fade'><div v-if='bubble' class='cards bubble' v-bind:style='[bubble_card ]'><div class='cards-header' style='border-top-left-radius: 10px;border-top-right-radius: 15px;border-bottom: none;background-color: transparent;'><button type='button' class='close badge' data-dismiss='alert' aria-label='Close' v-if='bubble' v-on:click='closeBubble' data-test='hello' style='font-size: xx-large;'><span class='customSpan-close' aria-hidden='true'>&times;</span></button></div><div class='cards-body bubble-body' ><img :src='bot' class='bubble-img'><div class='customH3' >{{ apiData.bubble_message }}</div></div><div class=' bubble-footer'v-bind:style='[bubble_footer]'><button v-on:click='openChat()' class='btns bubble-button'v-bind:style='[bubble_button]' > <b>{{ apiData.bubble_button_title }}</b> </button></div></div>   </transition>            <button v-if='show && !fullscreen' v-on:click='show = false,file_menu = false , bubble = false'  id='chat-widget-button' class='chat-widget-button btns btns-default'  v-bind:style='[cwidget_button]'> <span class='fas fa-times' style='margin-top: 1px;bottom: 10px;position: absolute;right:16px;font-size:37px;'></span></button><button v-if='!show' v-on:click='openChat()' id='chat-widget-button' class='chat-widget-button btns btns-default' v-bind:style='[cwidget_button]' > <span class='fas fa-comment-alt' style='bottom: 7px;position: absolute;right:10px;font-size:37px;'></span> <span class='chatwidget-badge' v-if='newMessagesCount!=0' v-bind:style='[cwidget_badge]'> <b>{{newMessagesCount}}</b> </span></button>";
    }
var html_template =`<div>
                      <transition name='fade'>
                        {{loadInterface}}` + header + `
                        <template v-for='message , index in messages'>
                          <div class='direct-chat-msg' v-bind:class='[apiData.display_user_icon==false? \"nouserlogomargin\" : \"\"]' v-if='message.direction==true'>
                            <div v-if='index == 0'>
                              <div class='direct-chat-info clearfix'>
                                <div class='direct-chat-name pull-left' v-bind:style='[dc_name ]'>
                                  {{message.user}}
                                </div>
                                <center>
                                  <span class='direct-chat-timestamp'v-bind:style='[dc_timestamp ]'>
                                    <div v-if='currentDate != message.date'>
                                      {{message.date}}&nbsp;
                                    </div >
                                    <div > {{message.time}}</div>
                                  </span>
                                </center>
                              </div>
                              <div class='direct-chat-img'>
                                <img :src='bot' class='chatavatar'>
                              </div>
                            </div>
                            <div v-if='index > 0'>
                              <div class='direct-chat-info clearfix'>
                                <div class='direct-chat-name pull-left' v-if='message.user != messages[index-1].user' v-bind:style='[dc_name ]'>
                                  {{message.user}}
                                </div>
                                <center>
                                  <span class='direct-chat-timestamp' v-bind:style='[dc_timestamp ]'v-if='message.date != messages[index-1].date || message.time != messages[index-1].time'>
                                    <div v-if='message.date != messages[index-1].date'>
                                      <div v-if='currentDate != message.date'>
                                        {{message.date}}&nbsp;
                                      </div >
                                    </div>
                                    <div v-if='message.time != messages[index-1].time' style='margin-left:5px;'>
                                      {{message.time}}
                                    </div>
                                  </span>
                                </center>
                              </div>
                              <div class='direct-chat-img' v-if='message.user != messages[index-1].user'>
                                <img :src='bot' class='chatavatar'>
                              </div>
                            </div>

                            <div class='direct-chat-carousel' v-if="message.content.media_block">
                              <div class="djbt-carousel-wrapper">
                                <div class="djbt-carousel"> 
                                <template v-for='element in message.content.media_block.elements'>
                                        <div class='djbt-slide' v-bind:style='[dc_text]'> 
                                          <div class="djbt-slide-img" v-if="element.image!=''">
                                            <img :src='element.image'>
                                          </div>
                                          <p>
                                            <b v-if="element.title!='' ">{{element.title}}</b><br> 
                                            <span v-if="element.subtitle">{{element.subtitle}}</span>
                                          </p> 
                                          <template v-for='button in element.buttons'> 
                                            <button v-if="button.type==='postback' "class='btns djbt-slideButton' @click='buttonClicked(button.title,button.value, index, button.type)'>{{button.title}}</button>
                                            <button v-if="button.type==='default' "class='btns djbt-slideButton' @click='buttonClicked(button.title,button.value, index, button.type)'>{{button.title}}</button>
                                            <button v-if="button.type==='' "class='btns djbt-slideButton'  @click='buttonClicked(button.title,button.value, index, button.type)' v-bind:style='[qckReply ]'>{{button.title}}</button> 
                                            <button v-if="button.type==='web' " class='btns djbt-slideButton' @click='openUrl(button.title, button.value, "_blank")' >{{button.title}}</button>
                                            <button v-if="button.type === 'webview'" class='btns djbt-slideButton' @click='showWebView(button.webview,button.title,0,button.type,button.close_action)'  v-b-modal=\"'modal-1'\" >
                                            {{button.title}}
                                          </button>
                                            <a v-if="button.type==='phone' "class='btns djbt-slideButton' :href="'tel:'+button.value" target='_blank'>{{button.title}}</a>
                                          </template>
                                        </div>
                                </template> 
                                </div>
                              </div>
                          </div>
            

                            <div class='direct-chat-text' v-bind:style='[dc_text]' v-if=\"message.content.text!='' || message.content.media!=''\">
                              <div v-if=\"message.content.media_position == 'top' && message.content.media!=''\" style='margin-bottom:10px;'>
                                <center>
                                  <img  :src='message.content.media'style='max-width: 90%;'  v-if=\"message.content.media!='' && message.content.media_type == 'image'\">
                                  <iframe class='dc_image' scrolling='no' :src='message.content.media' v-if=\"message.content.media!='' && message.content.media_type == 'audio'\"></iframe>
                                  <iframe class='dc_image' scrolling='no' :src='message.content.media' v-if=\"message.content.media!='' && message.content.media_type == 'video'\"></iframe>
                                  <iframe class='dc_image' scrolling='no' :src='message.content.media' v-if=\"message.content.media!='' && message.content.media_type == 'file'\"></iframe>
                                </center>
                                <br>
                              </div>
                              <div class='dc_message'>
                                <div v-html='message.content.text'></div>
                              </div>
                              <div v-if=\"message.content.media_position == 'bottom' && message.content.media!=''\" style='margin-bottom:10px;'>
                                <br>
                                <center>
                                  <img  :src='message.content.media'style='max-width: 90%;'   v-if=\"message.content.media!='' && message.content.media_type == 'image'\">
                                  <iframe class='dc_image' scrolling='no' :src='message.content.media' v-if=\"message.content.media!='' && message.content.media_type == 'audio'\"></iframe>
                                  <iframe class='dc_image' scrolling='no' :src='message.content.media' v-if=\"message.content.media!='' && message.content.media_type == 'video'\"></iframe>
                                  <iframe class='dc_image' scrolling='no' :src='message.content.media' v-if=\"message.content.media!='' && message.content.media_type == 'file'\"></iframe>
                                </center>
                                <br>
                              </div>
                            </div>
                            <div class='direct-chat-choice' v-if='message.content.has_buttons'  v-show='message.showbutton == true'>
                              <div>
                              <template v-for='(button, buttonIndex) in message.content.choices'> 
                                <button v-if=\"button.type === 'postback' && !message.content.multiple\" class='btns btns-default qckReply'  @click='buttonClicked(button.title,button.value, index, button.type)' v-bind:style='[qckReply ]'>
                                  {{button.title}}
                                </button>
                                <button v-if=\"button.type === '' && !message.content.multiple\" class='btns btns-default qckReply'  @click='buttonClicked(button.title,button.value, index, button.type)' v-bind:style='[qckReply ]'>
                                  {{button.title}}
                                </button>

                                <button v-if=\"button.type === 'postback' && message.content.multiple\" class='btns btns-default qckReply mcqckReply'  @click='mCbuttonClicked(button.title,button.value, index, buttonIndex, button.type)' v-bind:style='[mcqckReply]'>
                                  {{button.title}}
                                </button>
                                <button v-if=\"button.type === '' && message.content.multiple\" class='btns btns-default qckReply mcqckReply'  @click='mCbuttonClicked(button.title,button.value, index, buttonIndex, button.type)' v-bind:style='[mcqckReply,]'>
                                  {{button.title}}
                                </button>

                                <button v-if=\"button.type === 'web'\"  class='btns btns-default qckReply'   v-bind:style='[qckReply ]' @click='openUrl(button.title, button.value, button.target)'>
                                  {{button.title}}
                                </button>
                                <a v-if=\"button.type === 'phone'\"  class='btns btns-default qckReply'   v-bind:style='[qckReply ]' :href=\"'tel:'+button.value\" target='_blank'>
                                  {{button.title}}
                                </a>
                              </template>
                              <template v-for='button in message.content.buttons'>
                                <button v-if=\"button.type === 'webview'\" class='btns btns-default qckButton' @click='showWebView(button.url,button.title,index,button.type,button.close_action)'  v-bind:style='[qckButton ]' v-b-modal=\"'modal-1'\" >
                                  {{button.title}}
                                </button>
                                <button v-if=\"button.type === 'postback' && button.color === '#333'\" class='btns btns-default qckButton'  @click='buttonClicked(button.title,button.value, index, button.type)' v-bind:style='[qckButtonTime ]'>
                                  {{button.title}} 
                                </button>
                                <button v-if=\"button.type === 'postback' && button.color != '#333'\" class='btns btns-default qckButton'  @click='buttonClicked(button.title,button.value, index, button.type)' v-bind:style='[qckButton ]'>
                                  {{button.title}}
                                </button>
                                <button v-if=\"button.type === ''\" class='btns btns-default qckButton'  @click='buttonClicked(button.title,button.value, index, button.type)' v-bind:style='[qckButton ]'>
                                  {{button.title}}
                                </button>
                                <button v-if=\"button.type === 'web'\"  class='btns btns-default qckButton'   v-bind:style='[qckButton ]' @click='openUrl(button.title, button.value, button.target)'>
                                  {{button.title}}
                                </button>
                                <a v-if=\"button.type === 'phone'\"  class='btns btns-default qckButton'   v-bind:style='[qckButton ]' :href=\"'tel:'+button.value\" target='_blank'>
                                  {{button.title}}
                                </a>
                              </template>
                              <button v-if=\"message.content.continue_button\" class='btns btns-default qckReply continueBtn'  @click='validateMCbuttonClicked(index)' v-bind:style='[qckReply ]'>
                             {{message.content.continue_button}}
                            </button>
                            </div>
                          </div>
                        </div>
                        <div class='direct-chat-msg right' id='chtMsg' v-if='message.direction==false'  v-bind:class='[apiData.display_user_icon==false? \"nouserlogomargin\" : \"\"]'>
                          <div v-if='index == 0'>
                            <center>
                              <div class='direct-chat-info clearfix'>
                                <span class='direct-chat-timestamp' v-bind:style='[dc_timestamp ]'>
                                  <center>
                                    <div v-if='currentDate != message.date'>
                                      {{message.date}}&nbsp;
                                    </div > 
                                    {{message.time}}
                                  </center>
                                </span>
                              </div>
                              <div class='direct-chat-img' v-if='apiData.display_user_icon==true'>
                                <img :src='apiData.user_logo'  class='chatavatar'/>
                              </div>
                            </center>
                          </div>
                          <div v-if='index > 0'>
                            <center>
                              <div class='direct-chat-info clearfix'>
                                <span class='direct-chat-timestamp' v-bind:style='[dc_timestamp ]' v-if='message.date != messages[index-1].date || message.time != messages[index-1].time'>
                                  <div v-bind:style='[dc_timestamp ]' v-if='message.date != messages[index-1].date'>
                                    <div v-if='currentDate != message.date'>
                                      {{message.date}}&nbsp;
                                    </div >
                                  </div>
                                  <div v-bind:style='[dc_timestamp ]' v-if='message.time != messages[index-1].time' style='margin-left:5px;'>
                                    {{message.time}}
                                  </div>
                                </span>
                              </div>
                            </center>
                            <div class='direct-chat-img' v-if='apiData.display_user_icon==true && message.user != messages[index-1].user'>
                              <img :src='apiData.user_logo'  class='chatavatar'/>
                            </div>
                          </div>
                          <div class='direct-chat-text right' v-bind:style='[dc_text_right ]' v-if=\"message.content.text!='' || message.content.media!=''\">
                            <div v-if=\"message.content.media_position == 'top' && message.content.media!=''\" style='height: 220px;margin-bottom:10px;'>
                              <center>
                                <img  :src='message.content.media'style='max-width: 90%;'  height='200px' width='auto' v-if=\"message.content.media!='' && message.content.media_type == 'image'\">
                                <iframe class='dc_image' scrolling='no' :src='message.content.media' v-if=\"message.content.media!='' && message.content.media_type == 'audio'\"></iframe>
                                <iframe class='dc_image' scrolling='no' :src='message.content.media' v-if=\"message.content.media!='' && message.content.media_type == 'video'\"></iframe>
                                <iframe class='dc_image' scrolling='no' :src='message.content.media' v-if=\"message.content.media!='' && message.content.media_type == 'file'\"></iframe>
                              </center>
                              <br>
                              <br>
                            </div>
                            <div class='dc_message'>
                              <div v-html='message.content.text'></div>
                            </div>
                            <div v-if=\"message.content.media_position == 'bottom' && message.content.media!=''\" style='height: 220px;margin-bottom:10px;'>
                              <br>
                              <center>
                                <img  :src='message.content.media'style='max-width: 90%;'  height='200px' width='auto' v-if=\"message.content.media!='' && message.content.media_type == 'image'\">
                                <iframe class='dc_image' scrolling='no' :src='message.content.media' v-if=\"message.content.media!='' && message.content.media_type == 'audio'\"></iframe>
                                <iframe class='dc_image' scrolling='no' :src='message.content.media' v-if=\"message.content.media!='' && message.content.media_type == 'video'\"></iframe>
                                <iframe class='dc_image' scrolling='no' :src='message.content.media' v-if=\"message.content.media!='' && message.content.media_type == 'file'\"></iframe>
                              </center>
                              <br>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>`+ webviewTemplate + footer + `
                    <div class='input-groups'>

                      <button v-if='apiData.has_persistent_menu' style='background:transparent;border:none;color: white;padding: 4px 6px;' v-on:click='persistent_menu = !persistent_menu'>
                        <i class='fa fa-bars' style='font-size:x-large;'></i>
                      </button>

                      <div class='persistent-menu' v-if='persistent_menu!=false' v-bind:style='[cwidget_footer ]'>
                        <ul class="open">
                        <template v-for="action in apiData.persistent_menu.call_to_actions">
                          <persistent-menu-action :item="action" :actions="action.call_to_actions"></persistent-menu-action>
                        </template>
                        </ul>
                      </div>

                      <input id="chat-message" v-on:keyup.enter='sendMessage()' type='text' class='form-controls' :placeholder=\"$t('message.write_a_reply')\" style='margin-right:3px;font-size:15px;resize:none;height:auto;border-top-left-radius:5px;border-bottom-left-radius:5px;' >
                      <input type='file'v-if='uploadReady' @change='processFile($event)'  style='display:none;' ref='fileInputImage' accept='image/*' multiple='' id='img-attach' >
                      <input type='file'v-if='uploadReady' @change='processFile($event)'  style='display:none;' ref='fileInputAudio' accept='audio*' multiple='' id='audio-attach'>
                      <input type='file'v-if='uploadReady' @change='processFile($event)'  style='display:none;' ref='fileInputVideo' accept='video/*' multiple='' id='video-attach'>
                      <input type='file'v-if='uploadReady' @change='processFile($event)'  style='display:none;' ref='fileInput' accept='*' multiple='' id='file-attach'>
                      <div class='input-groups-append'>
                        <div class='file-menu' v-if='file_menu!=false' v-bind:style='[cwidget_footer ]'>
                          <div class='emoji-invoker' style='background:transparent;border:none;color: white; cursor:pointer;padding: 4px 6px;'@click='uploadImage'>
                            <i class='fas fa-file-image' style='font-size:x-large;'></i>
                          </div>
                          <div class='emoji-invoker' style='background:transparent;border:none;color: white; cursor:pointer;padding: 4px 6px;'@click='uploadAudio'>
                            <i class='fas fa-file-audio' style='font-size:x-large;'></i>
                          </div>
                          <div class='emoji-invoker' style='background:transparent;border:none;color: white; cursor:pointer;padding: 4px 6px;'@click='uploadVideo'>
                            <i class='fas fa-file-video' style='font-size:x-large;'></i>
                          </div>
                          <div class='emoji-invoker' style='background:transparent;border:none;color: white; cursor:pointer;padding: 4px 6px;'@click='uploadFile'>
                            <i class='fa fa-file' style='font-size:x-large;'></i>
                          </div>
                        </div>
                      <button class='emoji-invoker' style='background:transparent;border:none;color: white; cursor:pointer;padding: 4px 6px;'v-on:click='file_menu = !file_menu' >
                        <i class='fas fa-paperclip' style='font-size:x-large;vertical-align: baseline;'></i>
                      </button>
                      <button class='emoji-invoker' style='background:transparent;border:none;color: white;padding: 4px 6px;'  v-on:click='sendMessage'>
                        <i class='fab fa-telegram-plane' style='font-size:x-large;'></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </transition>` + chatButton + `</div>`;

// Ready translated locale messages
var i18n_messages = {
    en: {
      message: {
        hello:'Hello! How can we help?',
        discuss_now: 'Discuss Now',
        write_a_reply:'Write a message...'
      }
    },
    fr: {
      message: {
        hello:'Bonjour! En quoi pouvons nous aider?',
        discuss_now:'Discutez maintenant',
        write_a_reply:'Envoyer un message...',
      }
    },
    de: {
      message: {
        hello:'Hallo! Wie können wir helfen?',
        discuss_now :'Jetzt besprechen',
        write_a_reply:'Eine Nachricht schreiben...'
      }
    }
  }
// Set locale based on browser
var currentLocale = 'en';
if (typeof profile_language == 'undefined') {
    profile_language = 'en'
}
if (profile_language) {
  if (profile_language.indexOf('en')!== -1) {
    if (window.navigator.language.indexOf('en-')!== -1) {
      currentLocale = 'en';
    }else if (window.navigator.language.indexOf('fr-')!== -1) {
      currentLocale = 'fr';
    }else if (window.navigator.language.indexOf('de-')!== -1) {
      currentLocale = 'de';
    }
  }else if (profile_language.indexOf('fr')!== -1) {
    currentLocale = 'fr';
  }else if (profile_language.indexOf('de')!== -1) {
    currentLocale = 'de';
  }
}else{
    
}
// Create VueI18n instance with options
var i18n = new VueI18n({
    locale: currentLocale, // set locale
    messages:i18n_messages, // set locale messages
    // silentTranslationWarn: true
  })



callToActionTemplate = `
  <li v-bind:class="{ 'parent': isParent }">
    <label
      @click="clicked()">
      <span v-if="isParent" v-bind:class="{'fa fa-chevron-down': open, 'fa fa-chevron-right': !open}">
      </span>
      {{item.title}}
    </label>
    <template v-for="action in item.call_to_actions">
      <ul v-show="open" v-if="isParent" v-bind:class="{'open': open}">
        <persistent-menu-action :item="action" :actions="action.call_to_actions"></persistent-menu-action>
      </ul>
    </template>
  </li>
`;

Vue.component("persistent-menu-action", {
  template: callToActionTemplate,
  props: [
    'actions',
    'item'
  ],
  data: function() {
    return {
      open: false
    }
  },
  computed: {
    isParent: function() {
      return this.item.type == 'nested';
    }
  },
  methods: {
    clicked: function() {
      console.log(this.item);
      if (this.isParent) {
        this.open = !this.open;
      } else {
        switch (this.item.type) {
          case 'web_url':
            vueChatApp.showWebView(this.item.url, this.item.title);
            vueChatApp.persistent_menu = false;
            break;

          case 'postback':
            vueChatApp.sendText(this.item.title, this.item.payload);
            vueChatApp.persistent_menu = false;
            break;
        }
      }
    }
  }
});


// Vue.use(EmojiPicker)
vueChatApp = new Vue({
    i18n: i18n,
    el: "#app",
    data: function data() {
      return {
        scrollCount: 0,
        WebChatWSConnected: false,
        fullscreen: full_screen,
        ReconFuncId: null,
        openBubbleOnce: true,
        OpenBubbleShow: null,
        uploadReady: true,
        closeAction:'',
        showCode:false,
        file_menu: false,
        persistent_menu: false,
        mediaType: "",
        currentDate: moment().format('MMMM DD, YYYY'),
        newMessagesCount: 0,
        show: openChatBox,
        shown: false,
        scrolled: false,
        bubble: false,
        bubble_right:25,
        bubble_bottom:25,
        input_bar:true,
        bot: '',
        input: '',
        search: '',
        file: [],
        apiData: {},
        messages: [],
        qckButton: {
          'background-color': '#FFF',
          'border-color': '#FFF',
          'color': '#000'
        },
        qckButtonTime: {
          'background-color': '#e21a22',
          'border-color': '#e21a22',
          'color': '#FFF'
        },
        qckReply: {
          'background-color': '#FFF',
          'border-color': '#FFF',
          'color': '#000'
        },
        mcqckReply: {
          'background-color': '#FFF',
          'border-color': '#FFF',
          'color': '#000'
        },
        mcqckReplySelected: {
          'background-color': '#DDD',
          'border-color': '#FFF',
          'color': '#000'
        },
        dc_text: {
          "background": "white",
          "border": "1px solid white",
          "color": "black"
        },
        dc_text_right: {
          "background-color": " darkgrey",
          "border-color": "darkgrey",
          "color": "#000"
        },
        dc_timestamp: {
          'color': "#2c7297"
        },
        dc_name: {
          'color': "#535c6f",
          'font-weight': '600'
        },
        cwidget_header: {
          "background-color": "#7cc1dd",
          "color": "#fff"
        },
        cwidget: {
          "position": "fixed",
          "bottom":"90px",
          "right":"25px"
        },
        cwidget_body: {
          "background-color": "#d5ecf4",
          "height": bodyheight + "px"
        },
        cwidget_footer: {
          "background-color": "#7cc1dd",
          "color": "white"
        },
        cwidget_button: {
          "background-color": "#2c7297",
          "color": "white",
          "z-index": 10000,
          "right":"25px",
          "bottom":"25px",
          "position":"fixed"
        },
        cwidget_badge: {
          "color": "#fff",
          "background-color": "#ff5454"
        },
        bubble_card: {
          "border-color": "lightgray",
          "background-color": "white"
        },
        bubble_button: {
          "color": "#40a4cc"
        },
        bubble_footer: {
          "border-top": "1px solid #e4e6eb"
        },        
        ShowWebview: false,
        webViewUrl:'',
        webViewTitle:''
      };
    },
    template:  html_template,
    computed: {
      loadInterface: function loadInterface() {
        if (this.apiData.colors) {
          this.bot = this.apiData.logo;
          this.qckButton['background-color'] = this.apiData.colors.receivedMessage.bg;
          this.qckButton['border-color'] = this.apiData.colors.receivedMessage.bg;
          this.qckButton['color'] = this.apiData.colors.receivedMessage.text;
          this.qckReply['background-color'] = this.apiData.colors.receivedMessage.bg;
          this.qckReply['border-color'] = this.apiData.colors.receivedMessage.bg;
          this.qckReply['color'] = this.apiData.colors.receivedMessage.text;
          this.mcqckReply['background-color'] = this.apiData.colors.receivedMessage.bg;
          this.mcqckReply['border-color'] = this.apiData.colors.receivedMessage.bg;
          this.mcqckReply['color'] = this.apiData.colors.receivedMessage.text;
          this.dc_text['background-color'] = this.apiData.colors.receivedMessage.bg;
          this.dc_text['border'] = this.apiData.colors.receivedMessage.bg;
          this.dc_text['color'] = this.apiData.colors.receivedMessage.text;
          this.dc_text_right['background-color'] = this.apiData.colors.sentMessage.bg;
          this.dc_text_right['border-color'] = this.apiData.colors.sentMessage.bg;
          this.dc_text_right['color'] = this.apiData.colors.sentMessage.text;
          this.dc_timestamp['color'] = this.apiData.colors.launcher.text;
          this.cwidget_header['background-color'] = this.apiData.colors.header.bg;
          this.cwidget_header['color'] = this.apiData.colors.header.text;
          this.cwidget['right'] = this.apiData.position_right+'px';
          this.cwidget['bottom'] = (this.apiData.position_bottom+70)+'px';
          this.cwidget_body['background-color'] = this.apiData.colors.messageList.bg;
          this.cwidget_footer['background-color'] = this.apiData.colors.header.bg;
          this.cwidget_footer['color'] = this.apiData.colors.header.text;
          this.cwidget_button['background-color'] = this.apiData.colors.header.bg;
          this.cwidget_button['color'] = this.apiData.colors.header.text;
          this.cwidget_button['right'] = this.apiData.position_right+'px';
          this.cwidget_button['bottom'] = this.apiData.position_bottom+'px';
          this.dc_name['color'] = this.apiData.colors.operatorName.text;
        }
      }
    },
    methods: {
      sendMessage: function sendMessage() {
        console.log("sending")
        this._scrollDown();
        this.input = $('#chat-message').val();
        $('#chat-message').val('');
  
        if (this.input != '' || this.file != 0) {
          this.messages.push({
            user: "User",
            content: {
              text: this.input,
              media: this.file,
              media_type: this.mediaType,
              media_position: "",
              choices: [],
              buttons: []
            },
            direction: false,
            date: moment().format('MMMM DD, YYYY'),
            time: moment().format('hh:mm A')
          });
          this.newMessagesCount = 0;
          var wsMessage = {
            content: this.input
          };
          console.log(wsMessage);
          this.wsDoSend(wsMessage);
          this.input = '';
          this.mediaType = '';
          this.file = [];
  
          this._scrollDown();
        }
        
        this._scrollDown();
      },
      sendText: function(text, payload='') {
        this.messages.push({
          user: "User",
          content: {
            text: text,
            media: [],
            media_type: '',
            media_position: "",
            choices: [],
            buttons: []
          },
          direction: false,
          date: moment().format('MMMM DD, YYYY'),
          time: moment().format('hh:mm A')
        });
        this.newMessagesCount = 0;

        var wsMessage = {
          content: text
        };
        if (payload.length > 0){
          wsMessage = {
            content: text,
            payload: payload
          };
        }


        this.wsDoSend(wsMessage);
        this.input = '';
        this.mediaType = '';
        this.file = [];

        this._scrollDown();
      },
      showWebView: function(url,title,index,buttonType, close_action){
        processed_url = url.toLowerCase();
        console.log(processed_url.substring(0, 7) + ' and ' + processed_url.substring(0, 8));
        console.log("Close action :"+close_action)
        if (processed_url.substring(0, 7) != 'http://' && processed_url.substring(0, 8) != 'https://') {
          processed_url = location.protocol + '//' + processed_url;
        }
        this.ShowWebview = true;
        this.webViewUrl = processed_url;
        this.webViewTitle = title;
        this.closeAction = close_action;
        setTimeout(function() { 
          var fixed = document.getElementById('bubble-webview-webchat');

          fixed.addEventListener('touchmove', function(e) {

                e.preventDefault();

        }, false);
        
        }, 1000);
        
      },
      closeWebView: function(){

        this.ShowWebview = false;
        if(debug_urlsplit == '?debug=1'){console.log("Closing webview")}
        if (this.closeAction){
          var webviewClosed = {
              content: this.closeAction,
              payload: this.closeAction,
              silent: true
          }
          this.wsDoSend(webviewClosed);
        }
      },
      ConfirmOrder: function(){
        this.closeWebView();
        this.ShowWebview = false;     
        var confirmed_order = {
          command: 'confirmed_order' ,
        };  
        this.wsDoSend(confirmed_order);
      },
      //open URL in same window without target
      openUrl: function(title, url, target='_self') {
        processed_url = url.toLowerCase();
        if (processed_url.substring(0, 7) != 'http://' && processed_url.substring(0, 8) != 'https://') {
          processed_url = location.protocol + '//' + processed_url;
        }
        window.open(processed_url, target);
      },
      sendFile: function sendFile() {
        this._scrollDown();
  
        if (this.input != '' || this.file != 0) {
          var message = {
            user: "User",
            content: {
              text: this.input,
              media: this.file,
              media_type: this.mediaType,
              media_position: "top",
              choices: [],
              buttons: []
            },
            direction: false,
            date: moment().format('MMMM DD, YYYY'),
            time: moment().format('h:mm A')
          };
          this.messages.push(message);
          this.newMessagesCount = 0;
          this.input = '';
          this.mediaType = '';
          this.file = [];
          this._scrollDown();
        }
        this._scrollDown();
      },
      mCbuttonClicked: function mCbuttonClicked(title, answer, index,buttonIndex, buttonType) {
        this._scrollDown();
        console.log(title,answer,index,buttonIndex );
        var quickReplies = document.getElementsByClassName('mcqckReply');
        // this.messages[index].content.choices[buttonIndex]['title']="coucou"
        console.log(quickReplies);
        for (var i = 0; i < quickReplies.length; i++){
         if (i == buttonIndex){ 
          if( quickReplies.item(i).classList.contains('mcqckReplySelected')){
            quickReplies.item(i).classList.remove("mcqckReplySelected")
            quickReplies.item(i).style.borderColor = "gray"; 
            quickReplies.item(i).style.borderWidth ='thin'
          }else{
            quickReplies.item(i).classList.add("mcqckReplySelected")
            quickReplies.item(i).style.borderColor = "blue"; 
            quickReplies.item(i).style.borderWidth ='medium'
          }//mcqckReplySelected

          break;
          }
        }
      },
      validateMCbuttonClicked: function mCbuttonClicked( index) {
        this._scrollDown();
        selected_items = []
        selected_titles = []
        var quickReplies = document.getElementsByClassName('mcqckReply');
         for (var i = 0; i < quickReplies.length; i++){
          if( quickReplies.item(i).classList.contains('mcqckReplySelected')){
            selected_items.push(this.messages[index].content.choices[i]['value'])
            selected_titles.push(this.messages[index].content.choices[i]['title'])
          }
        }
        if (this.messages[index].content.choices && this.messages[index].content.choices != "undefined" && this.messages[index].content.choices.length > 0) 
        if (!this.messages[index].content.buttons || this.messages[index].content.buttons == "undefined" || this.messages[index].content.buttons.length == 0) 
        this.messages[index]['showbutton'] = false;
        for (var i = 0; i < selected_titles.length; i++){
          this.messages.push({
            user: "User",
            content: {
              text: selected_titles[i],
              media: null,
              media_type: null,
              media_position: "",
              choices: [],
              buttons: []
            },
            direction: false,
            date: moment().format('MMMM DD, YYYY'),
            time: moment().format('h:mm A')
          });
        }
        this.newMessagesCount = 0;
        this.input = '';
        this.mediaType = '';
        this.file = [];
        this._scrollDown();
        var elems = document.querySelectorAll(".mcqckReplySelected");

        [].forEach.call(elems, function(el) {
            el.classList.remove("mcqckReplySelected");
        });
        var elems = document.querySelectorAll(".mcqckReply");

        [].forEach.call(elems, function(el) {
            el.classList.remove("mcqckReply");
        });
        var wsButtonClicked = {
          content: selected_titles.join(", "),
          payload: selected_items
        };
        
        this.wsDoSend(wsButtonClicked);
      },
      buttonClicked: function buttonClicked(title, answer, index, buttonType) {
        this._scrollDown();
  
        this.messages.push({
          user: "User",
          content: {
            text: title,
            media: this.file,
            media_type: this.mediaType,
            media_position: "",
            choices: [],
            buttons: []
          },
          direction: false,
          date: moment().format('MMMM DD, YYYY'),
          time: moment().format('h:mm A')
        });
        this.newMessagesCount = 0;
        if (this.messages[index].content.choices && this.messages[index].content.choices != "undefined" && this.messages[index].content.choices.length > 0) if (!this.messages[index].content.buttons || this.messages[index].content.buttons == "undefined" || this.messages[index].content.buttons.length == 0) this.messages[index]['showbutton'] = false;
        this.input = '';
        this.mediaType = '';
        this.file = [];
  
        this._scrollDown();
  
        var wsButtonClicked = {
          content: title,
          payload: answer
        };
        this.wsDoSend(wsButtonClicked);
      },
      // append: function append(emoji) {
      //   this.input += emoji;
      // },
      handleScroll: function handleScroll() {
        this.scrolled = window.scrollY > 0;
        this.scrollCount = this.scrollCount + 1;
  
        if (this.shown != true && this.apiData.call_to_action != false && this.openBubbleOnce == true) {
          if (this.scrollCount == 100 && this.scrolled == true) {
            this.bubble = true;
            this.scrollCount = 0;
            this.openBubbleOnce = false;
          }
        } else if (this.scrollCount == 100) {
          this.scrollCount = 0;
        }
      },
      showBubble: function showBubble() {
        var isShowBubble = Cookies.get("isShowBubble")
        if (isShowBubble == undefined)
        {
          isShowBubble = "true"
          Cookies.set('isShowBubble', true);
        }
        if (this.shown != true && this.apiData.call_to_action != false && this.openBubbleOnce == true && isShowBubble == "true") {
          this.bubble = true;
          this.openBubbleOnce = false;
        }
      },
      closeBubble: function closeBubble() {
        Cookies.set('isShowBubble', false);
        this.bubble = false;
        this.openBubbleOnce = true;
      },
      uploadFile: function uploadFile() {
        this.$refs.fileInput.click();
        this.mediaType = 'file';
      },
      uploadImage: function uploadImage() {
        this.$refs.fileInputImage.click();
        this.mediaType = 'image';
      },
      uploadAudio: function uploadAudio() {
        this.$refs.fileInputAudio.click();
        this.mediaType = 'audio';
      },
      uploadVideo: function uploadVideo() {
        this.$refs.fileInputVideo.click();
        this.mediaType = 'video';
      },
      processFile: function processFile(event) {
        for (i = 0; i < event.target.files.length; i++) {
          var file = event.target.files[i];
          var user = this.session;
          var islast = 'false';
  
          if (i == event.target.files.length - 1) {
            islast = 'true';
          } //   if(debug_urlsplit == '?debug=1'){console.log(file.name)
  
  
          this.readFile(file, this.mediaType, user, islast);
          this.file = URL.createObjectURL(file);
          this.sendFile();
        }
  
        this.file = [];
  
        this._scrollDown();
  
        this.clear();
        this.file_menu = false;
      },
      readFile: function readFile(file, type, user, islast) {
        var me = this;
        var reader = new FileReader();
        var rawData = new ArrayBuffer();
        reader.onloadend = function (event) {
          // var is_sent = sendFile(reader.result, type, file.name);
          var wsFile = {
            inline_attachment: {
              type: type,
              name: file.name,
              data: reader.result,
              last: islast
            } //   if(debug_urlsplit == '?debug=1'){console.log(wsFile);
  
          };
          me.wsDoSend(wsFile);
        }, reader.onerror = function () {
          alert('There was an error reading the file!');
        };
        reader.readAsDataURL(file);
      },
      _scrollDown: function _scrollDown() {
        if (this.show == true) {
          this.$refs.scrollList.scrollTop = this.$refs.scrollList.scrollHeight;
        }
      },
      openChat: function openChat() {
        // called when the user clicks on the fab button to open the chat
        this._scrollDown();
  
        this.show = true;
        this.shown = true;
        this.bubble = false;
        this.newMessagesCount = 0;
  
        if (!this.WebChatWSConnected) {
          this.wsDoConnect();
        }
      },
      closeChat: function closeChat() {
        // called when the user clicks on the botton to close the chat
        this.show = false;
        this.file_menu = false;
      },
      clear: function clear() {
        var _this = this;
  
        this.uploadReady = false;
        this.$nextTick(function () {
          _this.uploadReady = true;
        });
      },
      wsDoConnect: function wsDoConnect() {
        var me = this;
        this.websocket = new WebSocket(djebots_webchat_ws_url);
  
        this.websocket.onopen = function (evt) {
          me.wsOnOpen(evt);
          if (alreadyStarted == false){
            me.gethistory();
          }
          alreadyStarted = true;
        };
  
        this.websocket.onclose = function (evt) {
          me.wsOnClose(evt);
        };
  
        this.websocket.onmessage = function (evt) {
          me.wsOnMessage(evt);
        };
  
        this.websocket.onerror = function (evt) {
          me.wsOnError(evt);
        };
        
        if(debug_urlsplit == '?debug=1'){console.log("connected");}
        me.WebChatWSConnected = true;
      },
      wsOnOpen: function(evt) {
        var me = this;
        // Code to execute after successful connection
        // if(debug_urlsplit == '?debug=1'){console.log("Now Connected to Websocket");
        if (typeof this.ReconFuncId != "undefined" || this.ReconFuncId != null) {
          clearTimeout(this.ReconFuncId);
        }
  
        connected = true;
  
        if (typeof djebots_ws_ping_interval == 'undefined') {
          djebots_ws_ping_interval = 5000;
        }
  
        window.setInterval(function () {
          me.ping();
        }, djebots_ws_ping_interval);
      },
      wsOnClose: function wsOnClose(evt) {
        var me = this;
        // Code to execute after connection has closed
        if (typeof djebots_ws_reconnect_timeout == 'undefined') {
          djebots_ws_reconnect_timeout = 1000;
        }
  
        connected = false;
        this.ReconFuncId = setTimeout(function () {
          if(debug_urlsplit == '?debug=1'){console.log("Reconnecting");}
          me.wsDoConnect();
        }, djebots_ws_reconnect_timeout);
      },
      wsOnMessage: function wsOnMessage(evt) {
        var me = this;
        var json = JSON.parse(evt.data); 
        if(debug_urlsplit == '?debug=1'){console.log(evt.data)}
        ServerResponseReceived = true;
  
        var media = "";
        var media_type = "";
        var media_position = "";
        var mdate = json['date'];
        var mtime = json['time'];
        var media_block = "";
        var has_buttons = false;
  
        if (json['choices'] || json['buttons']) {
          has_buttons = true;
        }
  
        var mdirection = json['direction'];
  
        if (typeof json['media'] != 'undefined') {
          media = json['media'];
        }
        if (typeof json['media_block'] != 'undefined') {
          media_block = json['media_block'];
        }
        if (typeof json['media_type'] != 'undefined') {
          media_type = json['media_type'];
        }
  
        if (typeof json['media_position'] != 'undefined') {
          media_position = json['media_position'];
        }
  
        if (typeof json['media_position'] != 'undefined') {
          media_position = json['media_position'];
        }
        if (typeof json['hide_input_bar'] != 'undefined') {
          this.input_bar = false;
        }else{
          this.input_bar = true;
        }
  
        if (typeof json['hide_input_bar'] != 'undefined') {
          this.input_bar = false;
        }else{
          this.input_bar = true;
        }

        if (typeof json['recieveHistory'] != 'undefined') {
          if (mdirection == true) {
            var message = {
              user: "",
              content: {
                text: me.urlify(json['text']),
                media: media,
                media_type: media_type,
                media_position: media_position,
                media_block: media_block,
                choices: json['choices'],
                buttons: json['buttons'],
                has_buttons: has_buttons,
                multiple:json['multiple'],
                continue_button:json['continue_button']
              },
              direction: true,
              date: mdate,
              time: mtime,
              showbutton: true
            };
            this.messages.push(message);
          } else {
            if (json['text'] != "" || media != "" || media_block != "") {
              var message = {
                user: "User",
                content: {
                  text: json['text'],
                  media: media,
                  media_type: media_type,
                  media_position: media_position,
                  media_block: media_block,
                  choices: json['choices'],
                  buttons: json['buttons'],
                  has_buttons: has_buttons,
                  multiple:json['multiple'],
                  continue_button:json['continue_button']
                },
                direction: false,
                date: mdate,
                time: mtime,
                showbutton: true
              };
              this.messages.push(message);
            }
          }
        } else {
          if (typeof json['live_agent'] != 'undefined') {
            var message = {
              user: json['live_agent'],
              content: {
                text: me.urlify(json['text']),
                media: media,
                media_type: media_type,
                media_position: media_position,
                media_block: media_block,
                choices: json['choices'],
                buttons: json['buttons'],
                has_buttons: has_buttons,
                multiple:json['multiple'],
                continue_button:json['continue_button']
              },
              direction: true,
              date: moment().format('MMMM DD, YYYY'),
              time: moment().format('h:mm A'),
              showbutton: true
            };
            this.messages.push(message);
            this.newMessagesCount += 1;
          } else {
            receiveMessageCounter = receiveMessageCounter+1;
            var message = {
              user: "",
              content: {
                text: me.urlify(json['text']),
                media: media,
                media_type: media_type,
                media_position: media_position,
                media_block: media_block,
                choices: json['choices'],
                buttons: json['buttons'],
                has_buttons: has_buttons,
                multiple:json['multiple'],
                continue_button:json['continue_button']
              },
              direction: true,
              date: moment().format('MMMM DD, YYYY'),
              time: moment().format('h:mm A'),
              showbutton: true
            };
            if (receiveMessageCounter < 2){
              this.messages.push(message);
              this.newMessagesCount += 1;
            }
            else{
              
              var delayedMessage= this.messages
              
              var delay = setTimeout(function(){
                delayedMessage.push(message);
              }, JSON.stringify((receiveMessageCounter-1)* bot_message_delay));
            }
            this.message = delayedMessage;
          }
        }
      },
      wsOnError: function wsOnError(evt) {
        if(debug_urlsplit == '?debug=1'){          
          console.log("Websocket error: ");
          console.log(evt);
        }
        Raven.captureException(evt);
      },
       
      wsDoSend: function wsDoSend(data) {
        try{
          this.websocket.send(JSON.stringify(data));
          receiveMessageCounter = 0;
        } catch(e) {
            Raven.captureException(e);
        }
      },
      gethistory: function gethistory() {
        if(debug_urlsplit == '?debug=1'){console.log("sending 'get_history'");}
        var jsonData = {};
        jsonData['get_history'] = 1;
        this.wsDoSend(jsonData);
        this.start();
      },
      start: function start() {
        if(debug_urlsplit == '?debug=1'){console.log("sending 'start'");}
        var jsonData = {};
        /*start instead of get history */
  
        jsonData['start'] = 1;
        this.wsDoSend(jsonData);
        var me = this;  
        window.setInterval(function () {          
          if (ServerResponseReceived == false){
            if(debug_urlsplit == '?debug=1'){console.log("The server isn't working fine");}
            me.start();
          }
          ServerResponseReceived = true;
        }, 4000);
      },
      ping: function ping() {
        if(debug_urlsplit == '?debug=1'){console.log("ping the server");}
        var jsonData = {};
        jsonData['ping'] = 1;
        this.wsDoSend(jsonData);
      },
      urlify: function urlify(text) {
        var isUrl = false;
        var urlRegex = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
        text = text.replace(urlRegex, function (url) {
          isUrl = true;
          return '<a href="' + url + '" target="_blank" >' + url + '</a>';
        });
  
        if (!isUrl) {
          var phoneExp = /(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?/img;
          return text.replace(phoneExp, function (phone) {
            return '<a href="tel:' + phone + '" target="_blank">' + phone + '</a>';
          });
        }
  
        return text;
      }
    },
    mounted: function mounted() {
      
      this._scrollDown();
  
      this.$nextTick(function () {
        var _this2 = this;
  
        // Code that will run only after the
        // entire view has been rendered
        if(debug_urlsplit == '?debug=1'){console.log(djebots_root_domain);}
  
        if (djebots_settings) {
          vueChatApp.$data.apiData = djebots_settings;
          this.interval = setInterval(function () {
            return _this2.showBubble();
          }, this.apiData.call_to_action_delay);
        } else {
          $.ajax({
            url: djebots_root_domain + "bots/api/?uhash=" + connector_uhash,
            success: function success(data) {
              var settings = data;
  
              if (settings.enabled) {
                djebots_settings = settings;
  
                if (!isNaN(settings.ping_interval)) {
                  djebots_ws_ping_interval = settings.ping_interval;
                }
  
                if (!isNaN(settings.reconnect_timeout)) {
                  djebots_ws_reconnect_timeout = settings.reconnect_timeout;
                }
  
                vueChatApp.$data.apiData = djebots_settings;
                vueChatApp.$data.interval = setInterval(function () {
                  return vueChatApp.showBubble();
                }, vueChatApp.$data.apiData.call_to_action_delay);
              }
            }
          });
        } //ajax call to for bot web chat and web chat widget
        // $.ajax({url: djebots_root_domain + "bots/api/?uhash=" + connector_uhash, success: function(data){
        //  vueChatApp.$data.apiData = data;
        // }});
  
      });
    },
    updated: function updated() {
      this.$nextTick(this._scrollDown());
    },
    destroyed: function destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    directives: {
      focus: {
        inserted: function inserted(el) {
          el.focus();
        }
      }
    },
    created: function created() {
      window.addEventListener('scroll', this.handleScroll); // this.interval = setInterval(() => this.showBubble(), this.apiData.call_to_action_delay);
  
      if (typeof djebots_webchat_widget_mode == 'undefined') {
        if(debug_urlsplit == '?debug=1'){console.log(window.location.pathname);}
  
        if (path.length < 4) {
          if (!session || session.length == 0) {
            session = guid();
          }
  
          Cookies.set('guid', session);
          var newPath = "/" + path[1] + "/" + path[2] + "/" + session + "/" + (typeof path[3] != 'undefined' && path[3] != session ? path[3] : '');
          if(debug_urlsplit == '?debug=1'){console.log(newPath);}
          window.location.href = newPath;
        } else {
          session = path[3];
          Cookies.set('guid', session);
        }
  
        ;
        if(debug_urlsplit == '?debug=1'){console.log(path.length);}
        if(debug_urlsplit == '?debug=1'){console.log(path[1]);}
      } else {
        if (!session || session.length == 0) {
          session = guid();
        }
      }
  
      if(debug_urlsplit == '?debug=1'){console.log(session);}
      djebots_webchat_ws_url = djebots_webchat_ws_url + "/" + session;
  
      if (djebots_webchat_ws_url.indexOf("https") != -1) {
        djebots_webchat_ws_url = djebots_webchat_ws_url.replace("https", "wss");
      } else if (djebots_webchat_ws_url.indexOf("http:") != -1) {
        djebots_webchat_ws_url = djebots_webchat_ws_url.replace("http", "ws");
      }
  
      if(debug_urlsplit == '?debug=1'){console.log("new URL: " + djebots_webchat_ws_url);}

      console.log(this.apiData)
      if (this.show) {
        this.wsDoConnect();
      }
      

      
    } });
